
(function(){
  var KEY='nliWishlistV1';
  function read(){try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}}
  function write(v){localStorage.setItem(KEY,JSON.stringify(v))}
  function keyOf(x){return x.handle||x.url}
  function syncButtons(){
    var list=read(), keys=list.map(keyOf);
    document.querySelectorAll('[data-nli-wishlist]').forEach(function(btn){
      var item={handle:btn.dataset.handle,title:btn.dataset.title,url:btn.dataset.url,price:btn.dataset.price};
      var active=keys.indexOf(keyOf(item))>-1;
      btn.setAttribute('aria-pressed',active?'true':'false');
      btn.textContent=active?'♥ Saved to Wishlist':'♡ Add to Wishlist';
    });
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-nli-wishlist]');
    if(!btn)return;
    var item={handle:btn.dataset.handle,title:btn.dataset.title,url:btn.dataset.url,price:btn.dataset.price};
    var list=read(), k=keyOf(item), idx=list.findIndex(function(x){return keyOf(x)===k});
    if(idx>-1)list.splice(idx,1);else list.unshift(item);
    write(list);syncButtons();renderWishlist();
  });
  function renderWishlist(){
    var root=document.querySelector('[data-nli-wishlist-page]');
    if(!root)return;
    var grid=root.querySelector('[data-nli-wishlist-grid]'), empty=root.querySelector('[data-nli-wishlist-empty]');
    var list=read();
    grid.innerHTML='';
    empty.hidden=list.length>0;
    list.forEach(function(item){
      var card=document.createElement('article');card.className='nli-wishlist-card';
      var h=document.createElement('h3');h.textContent=item.title||'Saved AI product';
      var p=document.createElement('p');p.textContent=item.price||'';
      var a=document.createElement('a');a.className='nli-btn';a.href=item.url||'/collections/all';a.textContent='View product';
      var b=document.createElement('button');b.type='button';b.className='nli-wish-btn';b.dataset.nliWishlist='';b.dataset.handle=item.handle||'';b.dataset.title=item.title||'';b.dataset.url=item.url||'';b.dataset.price=item.price||'';b.textContent='Remove';
      var actions=document.createElement('div');actions.className='nli-p3-actions';actions.append(a,b);
      card.append(h,p,actions);grid.append(card);
    });
  }
  document.addEventListener('DOMContentLoaded',function(){syncButtons();renderWishlist();});
})();
